import { extractMeshFromStore } from "@logic/lib/mesh"
import { findDeadEnds } from "@logic/lib/mesh/findFlaws/findDeadEnds"

import type { TransactionOperation } from "."
import { eraseEdge } from "."
import { eraseNode } from "./eraseNode"
import { edgeIndex, findEdgeState } from "../edges"
import { nodeIndex, findNodeState } from "../nodes"

export const removeDeadEnds: TransactionOperation = (transactors) => {
  const { get } = transactors
  let nodeIds = get(nodeIndex)
  let edgeIds = get(edgeIndex)
  let mesh = extractMeshFromStore({
    nodeIds,
    edgeIds,
    getNode: (id) => get(findNodeState(id)),
    getEdge: (id) => get(findEdgeState(id)),
  })
  let badNodes = findDeadEnds(mesh.nodes)

  const before = performance.now()
  const shouldContinue = (size: number, time: number) => {
    if (size === 0) {
      return false
    }
    const now = performance.now()
    if (now - time > 2000) {
      throw new Error(`Stuck removing dead ends from mesh`)
    }

    return true
  }
  while (shouldContinue(badNodes.size, before)) {
    badNodes.forEach((node) => {
      eraseNode(transactors, node.id)
    })

    nodeIds = get(nodeIndex)
    edgeIds = get(edgeIndex)
    mesh = extractMeshFromStore({
      nodeIds,
      edgeIds,
      getNode: (id) => get(findNodeState(id)),
      getEdge: (id) => get(findEdgeState(id)),
    })
    badNodes = findDeadEnds(mesh.nodes)
  }
}
